import { PackageStateType } from '~shared/types/pricing/state';
import { PackageActions } from '~shared/types/pricing/actions';
import ACTIONS from '~shared/actions';
import { PricingPackage } from '~shared/types/pricing/pricingsvc';

export default function packageReducer(state: PackageStateType, action: PackageActions): PackageStateType {
  const { type, payload } = action;

  if (type === ACTIONS.UPDATE_PACKAGES) {
    return {
      ...state,
      allPackages: payload?.allPackages ? payload.allPackages : state.allPackages,
      displayPackages: payload?.displayPackages,
    };
  }

  if (type === ACTIONS.UPDATE_PACKAGES_TO_DISPLAY) {
    return {
      ...state,
      packagesToDisplayState: payload?.packagesToDisplay,
    };
  }

  if (type === ACTIONS.SWITCH_PACKAGES) {
    const replacementPackage = state?.allPackages.find(pkg => Number(pkg?.id) === payload.replacedWith);
    const newPackages = state?.displayPackages?.map(pkg =>
      Number(pkg?.id) === payload?.packageToBeReplaced ? replacementPackage : pkg
    ) as PricingPackage[];

    return {
      ...state,
      displayPackages: newPackages ?? state.displayPackages,
    };
  }

  return state;
}
